import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

export default function LogoutPage() {
  const { logout } = useAuth();

  useEffect(() => {
    const performLogout = async () => {
      try {
        console.log('🚪 Direct logout route accessed');
        await logout();
      } catch (error) {
        console.error('❌ Logout failed:', error);
        // Redirect to login even if logout fails
        window.location.href = '/login';
      }
    };

    performLogout();
  }, [logout]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
      <div className="max-w-md w-full mx-auto p-6">
        <div className="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-8 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            Logging Out
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Please wait while we log you out...
          </p>
        </div>
      </div>
    </div>
  );
}
